import { PHASE, signed } from "./srUtil";

const listJoin = (a) => (a.length < 2 ? a[0] || "" : `${a.slice(0, -1).join(", ")} and ${a[a.length - 1]}`);

const Evidence = ({ v }) => {
  const e = v.evidence, b = v.base, strong = v.call === "strong";
  if (!e) return null;
  return (
    <>
      <p className="verdictev" data-testid="sr-verdict-evidence">
        {strong ? "Stocks in this spot" : "Stocks backed by 3+ top specialists"} beat their sector the next month{" "}
        <b>{Math.round(e.hit_pct)}%</b> of the time, by <b>{signed(e.mean)}%</b> on average
        {strong && b ? ` (${Math.round(b.hit_pct)}% and ${signed(b.mean)}% for all stocks the top specialists back).` : "."}
      </p>
      <p className="smallnote">{e.n.toLocaleString()} past cases.
        {strong ? "" : " Strong needs all three: a strong phase, options trading that isn’t heated, and a top-10 rank by the upside they see."}</p>
    </>
  );
};

export const RegimeVerdict = ({ v, symbol }) => {
  if (!v) return null;
  if (!v.call) {
    return (
      <div className="verdictbox none" data-testid="sr-regime-verdict">
        <span className="eyebrow">Next month</span>
        <h3 data-testid="sr-verdict-call">No call</h3>
        <p className="muted">Fewer than 3 top specialists own {symbol}. We only make a next-month call where past results back it,
          so below is where its holders’ thesis stands, not a forecast.</p>
      </div>
    );
  }
  const strong = v.call === "strong";
  return (
    <div className={`verdictbox ${v.call}`} data-testid="sr-regime-verdict">
      <span className="eyebrow">Next month</span>
      <h3 data-testid="sr-verdict-call">{strong ? "Strong" : "Neutral"}</h3>
      <p data-testid="sr-verdict-why">{strong
        ? `${v.n_specialists} top specialists back ${symbol}: their positions are in a strong phase, ${v.options_tracked ? "options trading isn’t heated" : "there’s no heated options trading on record"}, and it ranks #${v.rank} by the upside they see. This is our strongest pattern.`
        : `${v.n_specialists} top specialists back ${symbol}, but ${listJoin(v.reasons)}.`}</p>
      <Evidence v={v} />
    </div>
  );
};

export const RegimeSteps = ({ r, symbol }) => (
  <ol className="steps" data-testid="sr-regime-steps">
    <li><b>1</b><div><strong>The best long-term holders</strong>
      <small>{r.n_funds ? `The ${r.n_funds} fund${r.n_funds === 1 ? "" : "s"} with the best track records holding ${symbol}${r.funds?.length ? `; the top ${r.funds.length} are listed under “The funds behind it”` : ""}` : `The funds with the best track records holding ${symbol}`}</small></div></li>
    <li><b>2</b><div><strong>Their position vs the sector</strong>
      <small>How their positions have done against the sector since they bought, combined into one path</small></div></li>
    <li><b>3</b><div><strong>Matched to a typical path</strong>
      <small>One of 9 typical shapes, grouped into strong, neutral and weak phases</small></div></li>
  </ol>
);

export const PhasePill = ({ group, testid }) => {
  const p = PHASE[group];
  return p ? <span className={`pill ${p[1]}`} data-testid={testid}>{p[0]} phase</span> : null;
};
